import { FC, ReactNode } from "react";
import { useFormContext } from "react-hook-form";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useUpdateSKUMutation } from "@/data/mutations";
import { SKU } from "@/data/types";
import { SKUFormValues } from "@/lib/forms";

type Props = {
  sku: SKU;
  content: ReactNode;
};

export const WebpageAttributes: FC<Props> = ({ sku, content }) => {
  const updateSKUMutation = useUpdateSKUMutation(sku.id);

  const form = useFormContext<SKUFormValues>();

  const onSubmit = async (values: SKUFormValues) => {
    await updateSKUMutation.mutateAsync({
      builder_io_url: values.builder_io_url,
      builder_io_api_key: values.builder_io_api_key,
      login_type: values.login_type,
      redirect_url: values.redirect_url,
      header_logo_url: values.header_logo_url,
    });

    form.reset({}, { keepValues: true });
  };

  return (
    <Card>
      <CardHeader>
        <h4 className="text-lg font-medium leading-none">Webpage Settings</h4>
        <p className="text-sm text-muted-foreground">
          Customizations applied to the digital experience
        </p>
      </CardHeader>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <CardContent>{content}</CardContent>
        <div className="border-t px-6 py-4">
          <Button type="submit">Save</Button>
        </div>
      </form>
    </Card>
  );
};
